import React, { useEffect } from "react";
import { Box } from "@mui/material";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import BlogsHero from "../components/Blogs/BlogsHero";
import BlogCards from "../components/Blogs/BlogCards";

const Blogs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ overflowX: "hidden", backgroundColor: "#F5F7FA" }}>
      <Navbar />
      <Box sx={{ marginTop: "72px" }}>
        <BlogsHero />
        <BlogCards />
      </Box>
      <Footer />
    </Box>
  );
};

export default Blogs;
